import * as Yup from 'yup';

export const registerValidationSchema = Yup.object({
  firstName: Yup.string().required('Required field'),
  lastName: Yup.string().required('Required field'),
  email: Yup.string().email('Invalid E-mail').required('Required field'),
  password: Yup.string().required('Required field'),
});
